<template>
    <ValidationProvider tag="div" :rules="rules" :name="field.labelSC" :vid="field.id" v-slot="{ errors }">
        <input type="tel"
               :name="field.handle"
               :id="field.id"
               :required="field.required"
               :placeholder="field.placeholder"
               v-bind="attributes"
               :maxlength="field.maxLength"
               v-model="currentValue"
               :pattern="field.phone.pattern"
        />
        <small class="error">{{ errors[0] }}</small>
    </ValidationProvider>
</template>

<script>
    export default {
        props: {
            field: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                attributes: {},
                rules: {
                    required: this.field.required,
                },
                currentValue: '',
            }
        },
        watch: {
            currentValue(val) {
                this.$emit('input', val);
            }
        },
        mounted() {
            if (this.field.inputAttributes.length) {
                for (let i = 0; i < this.field.inputAttributes.length; i++) {
                    this.attributes[this.field.inputAttributes[i].attribute.toString()] = this.field.inputAttributes[i].value;
                }

                this.attributes = Object.assign({}, this.attributes);
            }

            this.currentValue = this.field.value;
        }
    }
</script>